import { Box } from "../../box";
import { forwardRef } from "react";
import { Keys, isNumber, mergeProps, useAutoFocusChild, useEventCallback, useFocusManager, useFocusScope, useKeyboardNavigation, useKeyedRovingFocus, useMergedRefs } from "../../shared";
import { Tab, TabKeyProp } from "./Tab";
import { useTabsContext } from "./TabsContext";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const NavigationKeyBinding = {
  horizontal: {
    first: [Keys.home],
    last: [Keys.end],
    next: [Keys.arrowRight],
    previous: [Keys.arrowLeft]
  },
  vertical: {
    first: [Keys.home],
    last: [Keys.end],
    next: [Keys.arrowDown],
    previous: [Keys.arrowUp]
  }
};
const DefaultElement = "div";
export function InnerTabList({
  as = DefaultElement,
  autoFocus,
  forwardedRef,
  tabs,
  ...rest
}) {
  const {
    isManual,
    onSelect,
    orientation,
    selectedKey
  } = useTabsContext();
  const [focusScope, setFocusRef] = useFocusScope();
  const tabRef = useMergedRefs(setFocusRef, forwardedRef);
  const focusManager = useFocusManager(focusScope, {
    keyProp: TabKeyProp
  });
  useKeyedRovingFocus(focusScope, selectedKey, {
    keyProp: TabKeyProp
  });
  useAutoFocusChild(focusManager, {
    delay: isNumber(autoFocus) ? autoFocus : undefined,
    isDisabled: !autoFocus,
    target: selectedKey
  });
  const handleKeyboardSelect = useEventCallback((event, element) => {
    onSelect(event, element === null || element === void 0 ? void 0 : element.getAttribute(TabKeyProp));
  });
  const navigationProps = useKeyboardNavigation(focusManager, NavigationKeyBinding[orientation], {
    onSelect: !isManual ? handleKeyboardSelect : undefined
  });
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      "aria-orientation": orientation,
      as,
      className: "o-ui-tab-list",
      ref: tabRef,
      role: "tablist"
    }, navigationProps),
    children: tabs.map(({
      elementType: ElementType = Tab,
      key,
      panelId,
      props,
      ref,
      tabId
    }) => /*#__PURE__*/_createElement(ElementType, { ...props,
      key: key,
      ref: ref,
      tab: {
        key,
        panelId,
        tabId
      }
    }))
  });
}
InnerTabList.defaultElement = DefaultElement;
export const TabList = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTabList, { ...props,
  forwardedRef: ref
}));